import debounce from 'lodash.debounce';
import {
  trackSnapshot,
  trackMarkerHover as trackHover,
  trackMarkerClick as trackClick,
} from '@rsos/components/capstone/common/Map/useDeckGL/spatialTracking';

/**
 * Tracks an Axon Dataset.
 * @param {string} layerKey - The key for the layer.
 * @param {object} dataset - The Axon dataset to be tracked, where keys are
 * @param {boolean} visible - Flag representing visibility of the layer.
 * the external id and values are the spatial object.
 */
export const trackAxonDataset = (layerKey, dataset = {}, visible) => {
  return new Promise(resolve => {
    try {
      trackSnapshot({
        layerKey,
        data: Object.values(dataset),
        selectStatus: d => d?.attributes?.device?.status || '',
        visible,
      });
    } finally {
      resolve();
    }
  });
};

/**
 * Axon uses DeckGL which repaints hovers in every frame refresh
 * which happens repeatedly during a hover event, this function
 * makes sure to debounce calls to the same hover event.
 */

export const trackMarkerHover = debounce((spatialLayerKey, info) => {
  trackHover(spatialLayerKey, info);
}, 500);

/**
 * Track clicks, debounced to avoid recording double clicking.
 */
export const trackMarkerClick = debounce((spatialLayerKey, info) => {
  trackClick(spatialLayerKey, info);
}, 500);
